import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../services/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class LoginRegisterGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly localStorageService = inject(LocalStorageService);

  canActivate(
    route: ActivatedRouteSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // Use the service which checks both token existence AND expiry
    const isAuthenticated = this.localStorageService.isAuthenticated();
    const shouldStartNewRegisterFlow =
      route.routeConfig?.path === 'register' &&
      route.queryParamMap.get('startNew') === 'true';

    if (isAuthenticated && !shouldStartNewRegisterFlow) {
      // Subscribed users have nothing left to do in register/checkout.
      return this.router.createUrlTree([
        this.localStorageService.isSubscribed() ? '/home' : '/checkout',
      ]);
    }

    return true;
  }
}
